import OrderV2PermissionsModal from "./modals/OrderV2PermissionsModal";
import OrderV2LocationsSelectModal from "./modals/OrderV2LocationsSelectModal";
import PermissionsSaga from "./saga";
import IConfig from "interfaces/IConfig";
import { registerModals } from "modals";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";

export const moduleName = "OrderV2.permissions";
export const url = "organsations";

const getConfig = (permissions: permissionsType, parentUrl: string) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };

    let routing: routingType = [];

    if (permissions["permissions.read"]) {
        config.active = true;
        registerModals({
            OrderV2LocationsSelectModal,
            OrderV2PermissionsModal,
        });
        store.injectSaga?.("OrderV2PermissionsSaga", PermissionsSaga);
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => parentUrl + "/" + item.path);
    }

    return { config, routing };
};

export default getConfig;
